import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TProductCart, adaptProductCartFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_PRODUCT_CART } from '../../backend-paths';


export const productCartDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_PRODUCT_CART}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_PRODUCT_CART}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptProductCartFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProductCart> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const productCartDeleteSlice = createSlice({
	name: 'productCartDeleteSlice',
	initialState,
	reducers: {
		clearProductCartDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[productCartDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[productCartDeleteApi.fulfilled.type]: (state, action: PayloadAction<TProductCart>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[productCartDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useProductCartDeleteSelector = () => useAppSelector(state => state[productCartDeleteSlice.name]);

export const { clearProductCartDelete } = productCartDeleteSlice.actions;
